package com.dotdrives.web.ui

import react.dom.events.MouseEvent
import web.dom.Element
import web.html.HTMLElement

/** Expand an existing action to its card/row while preserving native keyboard and nested controls. */
internal fun activateSurface(event: MouseEvent<*, *>) {
    if (event.defaultPrevented) return
    val target = event.target.unsafeCast<Element>()
    val surface = event.currentTarget.unsafeCast<Element>()
    val control = target.closest("button, a, input, select, textarea, label, summary, [role=button], [role=link], [contenteditable=true]")
    if (control != null && control != surface) return
    surface.querySelector(".dot-surface-action")?.unsafeCast<HTMLElement>()?.click()
}
